import {
  SalaryCardActions,
  SalaryCardState,
  SalaryCardActionTypes,
} from 'store/types/salaryCard'

const initialState: SalaryCardState = {
  detailInformationList: {
    employees: [],
    trustedPerson: {},
  },
  detailInfoStatus: 'idle',
  detailInfoError: null,
}

const orderDetailInfoReducer = (
  state = initialState,
  action: SalaryCardActions
): SalaryCardState => {
  switch (action.type) {
    case SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_REQUEST:
      return {
        ...state,
        detailInfoStatus: 'loading',
        detailInfoError: null,
      }
    case SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_SUCCESS:
      return {
        ...state,
        detailInfoStatus: 'success',
        detailInformationList: action.payload,
      }
    case SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_FAILURE:
      return {
        ...state,
        detailInfoStatus: 'failed',
        detailInfoError: action.payload,
      }
    default:
      return state
  }
}

export default orderDetailInfoReducer
